import { render, staticRenderFns } from "./Insumo.vue?vue&type=template&id=51a8c79a&"
import script from "./Insumo.vue?vue&type=script&lang=js&"
export * from "./Insumo.vue?vue&type=script&lang=js&"
import style0 from "./Insumo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports